<template>
	<div style="min-width: 1300px;">
		<layout>
			<div slot="body" style="padding: 0px 8%;">
				<metalcertificatecenter></metalcertificatecenter>
			</div>
		</layout>

	</div>
</template>

<script>
	import layout from '@/view/layout/index.vue'
	import metalcertificatecenter from './metalcertificate.vue'
	export default {
		name: 'metalcertificate',
		components: {
			layout: layout,
			metalcertificatecenter:metalcertificatecenter
		},
		methods:{
			downloadHzd:function(){
				window.location.href = "/static/metalcertificate/hz.doc";
			}
		}
	}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/view/metalcertificate/index.vue